import { render, staticRenderFns } from "./PatientGuarantorForm.vue?vue&type=template&id=69a77153&"
import script from "./PatientGuarantorForm.vue?vue&type=script&lang=js&"
export * from "./PatientGuarantorForm.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports